import React, { useRef } from 'react';
import { measureSlideData } from '../../constants';

import Slider from 'react-slick';

import { ReactComponent as MeasureArrow } from '../../assets/landing-page/wwm/arrow.svg';

const WWMSlider = ({ isMobile=false }) => {
  let measureSliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: isMobile ? 1 : 3,
    arrows: true,
    swipe: false,
    adaptiveHeight: isMobile ? true : false,
  };

  return (
    <div className='max-w-full h-max relative bg-white my-auto'>
      <Slider
        ref={(slider) => {
          measureSliderRef = slider;
        }}
        {...settings}
      >
        {measureSlideData.map((tab, index) => (
          <div key={index} className='!flex justify-between items-center md:items-start flex-col py-8 px-2 text-[#1c293a] h-full'>
            <div className='flex items-center md:items-start flex-col md:flex-row gap-4'>
              <img
                src={tab.img}
                className='w-[135px] h-[150px] object-contain mr-2'
                alt={`measure-img-${index+1}`}
              />
              <div className='relative flex flex-col text-left gap-1 mt-4'>
                <div className=''>
                  <div className='uppercase text-center md:text-left font-bold text-2xl'>{tab.title}</div>
                  <div className='text-lg text-center md:text-left max-w-[350px]'>{tab.subtitle}</div>
                </div>
              </div>
            </div>
            <div className='text-[15px] italic text-center md:text-left'>{tab.description}</div>
          </div>
        ))}
      </Slider>
      {/* <div className='arrow-wrapper'>
        <MeasureArrow
          className='arrow'
          onClick={() => handleArrowClick(measureTab - 1, 'minus')}
        />
        <MeasureArrow
          className='arrow -scale-x-100'
          onClick={() => handleArrowClick(measureTab + 1, 'plus')}
        />
      </div> */}
    </div>
  )
};

export default WWMSlider;